import { render, staticRenderFns } from "./BatchManage.vue?vue&type=template&id=72a84fda&scoped=true"
import script from "./BatchManage.vue?vue&type=script&lang=js"
export * from "./BatchManage.vue?vue&type=script&lang=js"
import style0 from "./BatchManage.vue?vue&type=style&index=0&id=72a84fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a84fda",
  null
  
)

export default component.exports